import {IAdvertiserCompany} from '@interfaces/advertiser/user';
import {State} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {AdvertiserUserService} from '../../services-advertiser/user/user.service';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {NgxsDataRepository} from "@angular-ru/ngxs/repositories";
import {Payload, StateRepository} from "@angular-ru/ngxs/decorators";
import {DataActionWithoutSubscription} from "@shared/functions";

interface AdvertiserUserStateModel {
  user: IAdvertiserCompany | null;
}

@StateRepository()
@State<AdvertiserUserStateModel>({
  name: 'advertiserUserState',
  defaults: {
    user: null
  }
})

@Injectable()
export class AdvertiserUserState extends NgxsDataRepository<AdvertiserUserStateModel> {
  constructor(private userService: AdvertiserUserService) {
    super();
  }

  @DataActionWithoutSubscription({cancelUncompleted: true})
  getCompanyData(): Observable<IAdvertiserCompany> {
    return this.userService.getCompanyData().pipe(
      tap((company) => {
        const state = this.ctx.getState();
        this.ctx.setState({...state, user: company});
      })
    );
  }

  @DataActionWithoutSubscription()
  updateCompanyData(@Payload('[Advertiser user state] update company data') payload: { companyName: string, address: string }): Observable<IAdvertiserCompany> {
    return this.userService.updateCompanyData({companyName: payload.companyName, address: payload.address})
      .pipe(
        tap((company) => {
          const state = this.ctx.getState();
          this.ctx.setState({...state, user: company});
        })
      );
  }
}
